/* Backend expects the passwordless username as an E.164 phone: "+<countrycode><number>".
   The national number is stripped to digits and loses any trunk-prefix zeros
   ("07911 123456" with +44 → "+447911123456"). */
export function buildUsername(dialCode, nationalNumber) {
  const digits = String(nationalNumber || '').replace(/\D/g, '').replace(/^0+/, '');
  return digits ? `+${dialCode}${digits}` : '';
}

/* Auto-formats a US number into (805) 680-6295 as the user types. */
export function formatPhoneUS(value) {
  const digits = String(value || '').replace(/[^0-9]/g, '').slice(0, 10);
  if (digits.length > 6) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length > 3) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (digits.length > 0) return `(${digits}`;
  return '';
}

/* "+15125550100" as the API stores it → "(512) 555-0100". Anything that isn't
   a US number is shown as stored. */
export function displayPhone(e164) {
  const digits = String(e164 || '').replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? formatPhoneUS(digits.slice(1)) : e164 || '';
}

/* "(512) 555-0100" → "+15125550100" for APIs that want E.164 US numbers. */
export function toE164US(formatted) {
  const digits = String(formatted || '').replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return digits ? `+${digits}` : '';
}

/* E.164 allows at most 15 digits total; require a plausible national part too. */
export function isValidPhone(dialCode, nationalNumber) {
  const digits = String(nationalNumber || '').replace(/\D/g, '').replace(/^0+/, '');
  return digits.length >= 4 && (String(dialCode) + digits).length <= 15;
}
